import { render, staticRenderFns } from "./GalleryTable.vue?vue&type=template&id=bdf33374&"
import script from "./GalleryTable.vue?vue&type=script&lang=js&"
export * from "./GalleryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports